import { useCallback } from 'react';
import { useCachedResource } from './useCachedResource'; // Adjust import path
import { appConfig } from '@/lib/AppConfig';
import { Area, AreaService } from '@/services/AreaService';

export const useAreaName = (areaId?: string) => {
  // Memoize the fetch function to preserve the context
  const fetchArea = useCallback(async (areaId: string) => {
    return await AreaService.getById(areaId);
  }, []);

  const { data, isLoading, error } = useCachedResource<Area>(
    areaId,
    appConfig.resourceTypes.area,
    fetchArea
  );

  return { areaName: data?.name || null, isLoading, error };
};